import { environment } from '../../../environments/environment';

export class SplunkConfig {
  // splunk api path
  url: string;
  // splunk auth token
  token: string;
  constructor() {
    this.url = environment.splunkMeta.url || '';
    this.token = environment.splunkMeta.token || '';
  }
}
